export default __webpack_public_path__ + "static/media/Smite of the Northern Wastes.1ac2e358.jpg";